// frontend/src/components/career/CareerPathCard.tsx

import { CareerPath } from '../../types/career.types';

interface CareerPathCardProps {
  career: CareerPath;
  isSelected: boolean;
  onSelect: () => void;
}

export function CareerPathCard({ career, isSelected, onSelect }: CareerPathCardProps) {
  return (
    <button type="button" className={`career-select-card ${isSelected ? 'selected' : ''}`} onClick={onSelect}>
      <div className="career-select-icon">{career.icon ?? '🚀'}</div>
      <div className="career-select-title">{career.title}</div>
      {career.description && <div className="career-select-desc">{career.description}</div>}
      {career.required_skills.length > 0 && (
        <div className="career-select-skills">
          {career.required_skills.slice(0, 3).map((skill) => (
            <span key={skill} className="career-select-skill-tag">
              {skill}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
